
import { MapPin } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

interface ContactInfoProps {
  service: any;
}

export const ContactInfo = ({ service }: ContactInfoProps) => {
  const isMobile = useIsMobile();
  
  // Only show contact info if there's a location
  if (!service.location) {
    return null;
  }
  
  return (
    <div className="space-y-2 mt-2">
      <h2 className="text-sm font-semibold">Location Information</h2>
      <div className="grid gap-1.5 grid-cols-1">
        {service.location && (
          <div className="flex items-center gap-1.5 p-1.5 bg-gray-50 rounded">
            <MapPin className="w-3.5 h-3.5 text-primary flex-shrink-0" />
            <div className="min-w-0">
              <div className="text-[10px] font-medium">Location</div>
              <div className="text-[10px] text-gray-600 truncate">{service.location}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
